import React, { FC } from "react"

import { BookFragmentFragment } from "@graphqlTypes"

import { generateConditionalClassName } from "@utils"

import AnchorLink from "@components/AnchorLink/AnchorLink"
import Observer from "@components/Observer/Observer"

import { PostBookNavNAV } from "./PostBookNav.styles"

const PostBookNav: FC<{
  currentChapterIndex?: number
  book?: BookFragmentFragment | null
  isStatic?: boolean
}> = ({
  currentChapterIndex,
  book,
  isStatic,
}) => {
    const { posts } = book || {}

    if (!posts) return

    return (
      <Observer>
        {(ref, isObserved) => (
          <PostBookNavNAV
            className={generateConditionalClassName({
              PostBookNav: true,
              "is-ready": isObserved,
              "is-static": !!isStatic,
            })}
            ref={ref}
          >
            {isStatic && (
              <h2 className="type--headline-medium-M">Chapters:</h2>
            )}
            <ul>
              {posts.map((post, i) => !post ? null : (
                <li key={post.id}>
                  <AnchorLink
                    className={generateConditionalClassName({
                      "type--text-S": true,
                      "is-active": i === currentChapterIndex,
                    })}
                    href={post.permalink || "/"}
                  >
                    <span>{i + 1}.</span> {post.title}
                  </AnchorLink>
                </li>
              ))}
            </ul>
          </PostBookNavNAV>
        )}
      </Observer>
    )
  }

export default PostBookNav
